import Api from './api.js';
import axios from 'axios';

export class ServiceApi extends Api {
    constructor(options = {}) {
        super(options);

        this.servicesApiPath = 'servicos';
    }

    async getServicesList(){
        return await this.axiosInstance.request({
            method: 'get',
            url: this.servicesApiPath,
        });
    }
}
